import { Heading, Img, Text } from "../../components";
import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ZFLOCE({
  projectTitle,
  projectType,
  imageSrc,
  backgroundImage,
  backgroundImage2,
  projectLink,
  ...props
}) {
  return (
    <div
      {...props}
      className={`relative flex flex-col w-full border-gray-100 border-2 border-solid bg-black rounded-[40px] hover:shadow-lg transition-shadow duration-300 overflow-hidden`}
    >
      {/* Background Layer */}
      <div
        className="absolute inset-0 bg-cover bg-center group-hover:bg-gray-950"
        style={{
          backgroundImage: `url(${backgroundImage})`,
        }}
      ></div>

      {/* Glass Effect Layer */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${backgroundImage2})`,
        }}
      ></div>

      {/* Image Section */}
      <div className="relative w-full h-[413px] rounded-t-[40px] overflow-hidden group">
        <Img
          src={imageSrc}
          alt={projectTitle}
          className="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-110"
        />
      </div>

      {/* Text Section */}
      <div className="relative flex flex-col items-start p-6 gap-2 bg-gray-950 rounded-b-[40px]">
        <Link to={projectLink} target="_blank">
        <ArrowUpRight className="absolute top-4 right-4 text-white-a700 w-6 h-6 cursor-pointer" />
        </Link>

        <Text
          size="textxs"
          as="p"
          className="text-[24px] sm:text-[16px] font-light text-white-a700"
        >
          {projectType}
        </Text>
        <Heading
          size="textxs"
          as="p"
          className="text-[32px] sm:text-[28px] font-normal text-white-a700 uppercase tracking-wide"
        >
          {projectTitle}
        </Heading>
      </div>
    </div>
  );
}


